import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {route} from "../../../routes";
import {
  GelContentContainer,
  GelContentRow,
  GelContentColumn,
  SubHeading,
  SideNavigation,
  ButtonBackToTop,
  Sanitize
} from "cw-styleguide-react";
import Helmet from 'react-helmet';

class ArticlesDetailView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} | {this.props.t('route_articles_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route("articles") + route('article', {article: this.props.data.slug})}>
          {this.props.data.name}
        </BreadcrumbsItem>
        <GelContentContainer>
          <SubHeading type={'sub-heading-small'} colour={'sub-heading-small--b'}>
            {this.props.t('articles_subtitle')}
          </SubHeading>
          <h1 style={{marginTop: '-15px'}}>{this.props.data.name}</h1>
          <Sanitize html={this.props.data.overview} classes={['style--list-circle','style--list-no-bg']}   />
          <GelContentRow>
            <GelContentColumn md={3}>
              <SideNavigation title={this.props.t('contents')} items={this.props.data.introductionIndexes.map((item) => {
                return {url: '#' + item.id, text:item.title}
              })}/>
            </GelContentColumn>
            <GelContentColumn md={9}>
              <div className={'gel-content-main'}>
                <Sanitize html={this.props.data.introduction} classes={['style--list-circle','style--list-no-bg']}/>
                <ButtonBackToTop/>
              </div>
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(ArticlesDetailView);
